import React, { Component } from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

class Home extends Component {
  state = {}

  goToRoute = route => {
    this.props.history.push(route)
  }

  render() { 
    const { store } = this.props
    return (
      <div>
        <Card.Group>
          <Card link onClick={() => this.goToRoute('/customers')}>
            <Card.Content>
              <Card.Header>
                <Icon name={store.isLoadingCustomers ? 'refresh' : 'users'} /> Customers
              </Card.Header>
              <Card.Meta>Your customers</Card.Meta>
            </Card.Content>
          </Card>
          <Card link onClick={() => this.goToRoute('/products')}>
            <Card.Content>
              <Card.Header>
                <Icon name='archive' /> Quotes
              </Card.Header>
              <Card.Meta>Quoted products and services</Card.Meta>
              <Card.Description>
                Add parts, labour and other costs to quotes to get estimates for different quantities.
              </Card.Description>
            </Card.Content>
          </Card>
          <Card link onClick={() => this.goToRoute('/materials')}>
            <Card.Content>
              <Card.Header>
                <Icon name='cubes' /> Saved Materials
              </Card.Header>
              <Card.Meta>Commonly used materials</Card.Meta>
              <Card.Description>
                Used when adding parts to a quote. Materials can be also be created on-the-fly
                when estimating a quote.
              </Card.Description>
            </Card.Content>
          </Card>
          <Card link onClick={() => this.goToRoute('/standardOperations')}>
            <Card.Content>
              <Card.Header>
                <Icon name='configure' /> Standard Operations
              </Card.Header>
              <Card.Meta>Common labour operations</Card.Meta>
              <Card.Description>
                Including default setup and operation times. Like materials, labour
                operations can be created on-the-fly.
              </Card.Description>
            </Card.Content>
          </Card>
        </Card.Group>
      </div>
    )
  }
}
 
export default withRouter(inject('store')(observer(Home)));


// WEBPACK FOOTER //
// ./src/components/Home.js